import { ActiveBooleanFeatureFlag } from "@/types/ActiveFeatureFlag";
import { useFeatureFlagEnabled } from "posthog-js/react";

//Checks whether a flag is available on posthog.
//Don't use it for posthog experiments.
export default function useIsFlagEnabled(
  featureName: ActiveBooleanFeatureFlag
) {
  return useFeatureFlagEnabled(featureName);
}
